import { User } from "../types/user";

export function hasPermission(user: User | null, permission: string): boolean {
  if (!user?.permissions || !Array.isArray(user.permissions)) {
    return false;
  }
  return user.permissions.includes(permission);
}
